import createIcon from '../../createIcon';

/**
 * @component @name LaptopChromebook
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTguNVYzLjVIMlYxOC41SDBWMjAuNUgyNFYxOC41SDIyWk0xNCAxOC41SDEwVjE3LjVIMTRWMTguNVpNMjAgMTUuNUg0VjUuNUgyMFYxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LaptopChromebook = createIcon('LaptopChromebook', [
  [
    'path',
    {
      d: 'M22 18.5V3.5H2V18.5H0V20.5H24V18.5H22ZM14 18.5H10V17.5H14V18.5ZM20 15.5H4V5.5H20V15.5Z',
      key: 'iie3oy',
    },
  ],
]);

export default LaptopChromebook;
